import { DropdownButton } from "@biteship/atom";

export default function FilterButton(props) {
  return (
    <DropdownButton
      className="w-full"
      menuClassName={props.menuClassName}
      dropdownOrientation={props.dropdownOrientation}
      customButtonComponent={
        <button
          type="button"
          onClick={props.onClick}
          className={`inline-flex w-full px-4 py-2 border ${
            props.activeFilter > 0 ? "border-primary" : "border-gray-300"
          } shadow-sm text-sm rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none`}
        >
          <div className="flex flex-row align-middle">
            <div className="flex align-middle justify-center text-gray-700">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                width="12"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            {props.activeFilter > 0 ? (
              <div className="text-sm ml-2 md:mr-2 text-gray-900 whitespace-nowrap">
                {props.activeFilter} Filter Aktif
              </div>
            ) : (
              <div className="text-sm ml-2 md:mr-2">{props.buttonTitle}</div>
            )}
          </div>
        </button>
      }
      actions={[
        [
          {
            title: (
              <div className="whitespace-nowrap cursor-auto font-sans not-italic font-bold text-sm leading-5 text-gray-900 flex flex-row order-1 flex-grow-0">
                <div className="ml-1">{props.filterTitle}</div>
              </div>
            ),
            disabled: true,
          },
          ...props.filters.map((filter) => ({
            title: (
              <div className="font-sans not-italic flex justify-between">
                <div className="whitespace-nowrap text-sm leading-5 text-neutral-90 flex flex-row flex-grow-0">
                  <div>
                    <input
                      type="checkbox"
                      checked={filter.checked}
                      name="waitingToPick"
                      onClick={(e) => {
                        e.stopPropagation();
                        filter.onSelect();
                      }}
                      className="border cursor-pointer border-gray-500 w-5 h-5 accent-primary bg-white rounded-md"
                    />
                  </div>
                  <div className="ml-2 cursor-auto">{filter.title}</div>
                </div>
                <div className="text-xs font-bold text-primary ml-8 mt-0.5">{filter.count}</div>
              </div>
            ),
            onClick: (e) => {
              e.preventDefault();
            },
          })),
          {
            title: (
              <div className="whitespace-nowrap font-sans not-italic font-bold text-xs leading-5 text-primary flex flex-row order-1 flex-grow-0">
                <div className="ml-1">Reset Filter</div>
              </div>
            ),
            onClick: () => props.onResetFilters(),
          },
        ],
      ]}
    />
  );
}
